import getLocation from '@justpark/api/src/requests/getLocation';

const landingLoader = async ({ params, pathname, jpApiClient }) => {
  const { country, slug } = params;

  const { geoLocation, hasError, newSlug } = await jpApiClient(
    getLocation(country, slug, pathname)
  )
    .then(({ data }) => ({ geoLocation: data.data }))
    .catch((error) => ({
      hasError: true,
      newSlug: error?.response?.data?.newSlug
    }));

  return { geoLocation, hasError, newSlug };
};

export default landingLoader;
